export function GetProductPageConfig () {
  if (window.dbsProductsReviewsConfig) {
    return {
      productId: window.dbsProductsReviewsConfig.productId,
      productName: window.dbsProductsReviewsConfig.productName,
      productManufacturer: window.dbsProductsReviewsConfig.productManufacturer,
      productDescription: window.dbsProductsReviewsConfig.productDescription,
      productPicture: window.dbsProductsReviewsConfig.productPicture
    }
  }

  return {}
}



// WEBPACK FOOTER //
// ./src/config/productPageConfig.js